// extracted by mini-css-extract-plugin
export default {"content":"index_content_xhXrA","space":"index_space_RypcQ","noThisAccount":"index_noThisAccount_thiz0"};